//import './clinic-card';

import './_mainnav_hovering';
import './_mainnav_img_extension';
//import './_menu-addons';
import './_external-link-modal';
import './_searchbar_animation';
import './_scroll-indicator';
import './_animation-pausing';
import './ume-blocks-ukessen/menu-part-with-image-block';
import clinicCardButtonPosition from "./clinic-card-button-position";
import menuPartMagic from "./ume-blocks-ukessen/menu-part-li-click";
import './_menu-part-with-image-block';
import clinicCardSetFocus from "./clinic-card-set-focus";


import $ from 'jquery';

$(document).ready(() => {
    clinicCardButtonPosition();
    menuPartMagic();
    clinicCardSetFocus();
});
let currentWidth = window.innerWidth;
window.addEventListener('resize', () => {
    if(currentWidth === window.innerWidth) return;
    clinicCardButtonPosition();

    currentWidth = window.innerWidth;

});

